import { render, staticRenderFns } from "./Deselect.vue?vue&type=template&id=140dd51b&"
import script from "./Deselect.vue?vue&type=script&lang=ts&"
export * from "./Deselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports